import { useRef, useCallback, useContext } from 'react';
import { EventType, metadataAdClick, sendAdTechEvent } from 'analytics/gtmServerFunctions';
import { useSelector } from 'redux/hooks';
import { getProductClickData } from 'redux/modules/entities/selectors/products';
import isEqual from 'lodash/isEqual';

import { handleProductListClick } from 'utils/gtm';
import CarouselContext from 'components/Carousel/CarouselContext';

export const usePodClickTracking = ({
  conflictMessage,
  isFavourite,
  position,
  productId,
  searchType,
  wrapperId,
  boosted,
  sponsored,
  sponsorshipId,
  listDefinitions,
  orderId,
  promotions,
  podType,
  purchaseOrAmend,
  tracking = undefined,
}) => {
  // TODO: Migrate all product to impression mapping to a shared selector utility
  // REF: https://johnlewispartnership.atlassian.net/browse/SHOPEXP-90
  const productData = useSelector(state => getProductClickData(state, productId), isEqual);
  const { metadata } = productData;

  const clickSentToAdTech = useRef(false);

  const reportClickToAdTech = useCallback(() => {
    if (!clickSentToAdTech.current) {
      sendAdTechEvent({
        eventType: EventType.CLICK,
        sponsorshipId,
        trackingUrls: tracking?.clickUrls,
        vendor: tracking?.vendor,
      });
      clickSentToAdTech.current = true;
    }
  }, [sponsorshipId, tracking]);

  const reportClickToMonetate = useCallback(() => {
    if (metadata) metadataAdClick(metadata);
  }, [metadata]);

  const { productFindingMethod } = useContext(CarouselContext);

  const reportClickToDataLayer = useCallback(() => {
    handleProductListClick({
      conflictMessage,
      isFavourite,
      position,
      productData,
      searchType,
      wrapperId,
      boosted,
      sponsored,
      sponsorshipId,
      productFindingMethod,
      listDefinitions,
      orderId,
      promotions,
      podType,
      purchaseOrAmend,
    });
  }, [
    boosted,
    conflictMessage,
    isFavourite,
    listDefinitions,
    orderId,
    podType,
    position,
    productData,
    promotions,
    purchaseOrAmend,
    searchType,
    sponsored,
    sponsorshipId,
    wrapperId,
    productFindingMethod,
  ]);

  const reportAnalyticsClick = useCallback(() => {
    reportClickToDataLayer();
    reportClickToAdTech();
    reportClickToMonetate();
  }, [reportClickToAdTech, reportClickToDataLayer, reportClickToMonetate]);

  return {
    reportClickToDataLayer,
    reportClickToAdTech,
    reportClickToMonetate,
    reportAnalyticsClick,
  };
};
